import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

/**
 * Help popover that describes available template variables for notification templates.
 */
export function TemplateVariablesHelp() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="h-auto p-1">
          <HelpCircle className="h-4 w-4" />
          <span className="sr-only">Template variables help</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-96" align="start">
        <div className="space-y-4">
          <div>
            <h4 className="font-medium mb-2">Template Variables</h4>
            <p className="text-sm text-muted-foreground mb-3">
              Use <code className="bg-muted px-1 rounded">{'{{ variableName }}'}</code> syntax.
              Whitespace inside brackets is allowed.
            </p>
          </div>

          <div>
            <h5 className="text-sm font-medium mb-1">User Variables</h5>
            <p className="text-xs text-muted-foreground mb-2">
              Available for user-targeted and org-targeted notifications.
            </p>
            <ul className="text-sm space-y-1">
              <li><code className="bg-muted px-1 rounded">{'{{ user.id }}'}</code> - User ID</li>
              <li><code className="bg-muted px-1 rounded">{'{{ user.email }}'}</code> - Email address</li>
              <li><code className="bg-muted px-1 rounded">{'{{ user.firstName }}'}</code> - First name</li>
              <li><code className="bg-muted px-1 rounded">{'{{ user.lastName }}'}</code> - Last name</li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-medium mb-1">Organization Variables</h5>
            <p className="text-xs text-muted-foreground mb-2">
              Available only for org-targeted notifications.
            </p>
            <ul className="text-sm space-y-1">
              <li><code className="bg-muted px-1 rounded">{'{{ org.id }}'}</code> - Organization ID</li>
              <li><code className="bg-muted px-1 rounded">{'{{ org.name }}'}</code> - Organization name</li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-medium mb-1">Custom Variables</h5>
            <p className="text-xs text-muted-foreground">
              Additional variables can be passed in the notification event data.
              These override auto-injected values if names conflict.
            </p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
